import { makeVar } from "@apollo/client";

import { GetUserProgramsByServiceQuery } from "../../graphql/operations/get-user-program-by-service";

export const userProgramsData = makeVar<
  GetUserProgramsByServiceQuery | undefined
>(undefined);
